module.exports = __webpack_public_path__ + "static/media/red_ballon.940e6e0b.png";